import React, { useState, useEffect } from "react";
import "./GalleryPage.css";
import BgImage from "../Component/bg-image.jpg";

// ✅ Import all your images here
import img1 from "../Component/Slide 1.jpg";
import img2 from "../Component/Slide 2.jpg";
import img3 from "../Component/Slide 3.jpg";
import img4 from "../Component/Slide 4.jpg";
import img5 from "../Component/Slide 5.jpg";
import img6 from "../Component/Slide 6.jpg";
import img7 from "../Component/Slide 7.jpg";
import img8 from "../Component/Slide 8.jpg";
import img9 from "../Component/Slide 9.jpg";
import img10 from "../Component/Slide 10.jpg";

import img33 from "../Component/IMG-20251113-WA0001.jpg";
import img34 from "../Component/IMG-20251113-WA0002.jpg";
import img35 from "../Component/IMG-20251113-WA0003.jpg";
import img36 from "../Component/IMG-20251113-WA0004.jpg";
import img37 from "../Component/IMG-20251113-WA0005.jpg";
import img38 from "../Component/IMG-20251113-WA0006.jpg";
import img39 from "../Component/IMG-20251113-WA0007.jpg";
import img40 from "../Component/IMG-20251113-WA0008.jpg";
import img41 from "../Component/IMG-20251113-WA0009.jpg";
import img42 from "../Component/IMG-20251113-WA0010.jpg";
import img43 from "../Component/IMG-20251113-WA0011.jpg";
import img44 from "../Component/IMG-20251113-WA0012.jpg";
import img45 from "../Component/IMG-20251113-WA0013.jpg";
import img46 from "../Component/IMG-20251113-WA0014.jpg";
import img47 from "../Component/IMG-20251113-WA0015.jpg";
import img48 from "../Component/IMG-20251113-WA0016.jpg";
import img49 from "../Component/IMG-20251113-WA0017.jpg";
import img50 from "../Component/IMG-20251113-WA0018.jpg";
import img51 from "../Component/IMG-20251113-WA0019.jpg";
import img52 from "../Component/IMG-20251113-WA0020.jpg";
import img53 from "../Component/IMG-20251113-WA0021.jpg";
import img54 from "../Component/IMG-20251113-WA0022.jpg";
import img55 from "../Component/IMG-20251113-WA0023.jpg";
import img56 from "../Component/IMG-20251113-WA0024.jpg";
import img57 from "../Component/IMG-20251113-WA0025.jpg";
import img58 from "../Component/IMG-20251113-WA0026.jpg";
import img59 from "../Component/IMG-20251113-WA0027.jpg";
import img60 from "../Component/IMG-20251113-WA0028.jpg";
import img61 from "../Component/IMG-20251113-WA0029.jpg";
import img62 from "../Component/IMG-20251113-WA0030.jpg";
import img63 from "../Component/IMG-20251113-WA0031.jpg";
import img64 from "../Component/IMG-20251113-WA0032.jpg";
import img65 from "../Component/IMG-20251113-WA0033.jpg";
import img66 from "../Component/IMG-20251113-WA0034.jpg";
import img67 from "../Component/IMG-20251113-WA0035.jpg";
import img68 from "../Component/IMG-20251113-WA0037.jpg";
import img69 from "../Component/IMG-20251113-WA0038.jpg";
import img70 from "../Component/IMG-20251113-WA0039.jpg";
import img71 from "../Component/IMG-20251113-WA0040.jpg";
import img72 from "../Component/IMG-20251113-WA0041.jpg";
import img73 from "../Component/IMG-20251113-WA0042.jpg";
import img74 from "../Component/IMG-20251113-WA0043.jpg";
import img75 from "../Component/IMG-20251113-WA0044.jpg";
import img76 from "../Component/IMG-20251113-WA0046.jpg";
import img77 from "../Component/IMG-20251113-WA0047.jpg";
import img78 from "../Component/IMG-20251113-WA0048.jpg";
import img79 from "../Component/IMG-20251113-WA0049.jpg";
import img80 from "../Component/IMG-20251113-WA0050.jpg";
import img81 from "../Component/IMG-20251113-WA0051.jpg";
import img82 from "../Component/IMG-20251113-WA0052.jpg";
import img83 from "../Component/IMG-20251113-WA0053.jpg";
import img84 from "../Component/IMG-20251113-WA0054.jpg";
import img85 from "../Component/IMG-20251113-WA0055.jpg";
import img86 from "../Component/IMG-20251113-WA0056.jpg";
import img87 from "../Component/IMG-20251113-WA0057.jpg";
import img88 from "../Component/IMG-20251113-WA0058.jpg";

const GalleryPage = () => {
  const images = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
    img33, img34, img35, img36, img37, img38, img39, img40, img41, img42,
    img43, img44, img45, img46, img47, img48, img49, img50, img51, img52,
    img53, img54, img55, img56, img57, img58, img59, img60, img61, img62,
    img63, img64, img65, img66, img67,  img70, img71, img72,
     img74, img75, img76, img77,  img79, img80, img81, img82,
    img83, img84, img85, img86, img87, img88, img68, img69,img78,img73
  ];

  const [currentIndex, setCurrentIndex] = useState(null);

  // ✅ Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentIndex === null) return;
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") setCurrentIndex(null);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div
      className="gallery-page"
      style={{
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="overlay"></div>

      {/* 🔹 Header Section */}
      <div className="gallery-header glass-box">
        <h1 className="gallery-title">CPIT Gallery</h1>
        <p className="gallery-subtitle">
          Explore CPIT’s journey — events, training sessions, and student achievements captured in moments.
        </p>
      </div>

      {/* 🔹 Gallery Grid */}
      <div className="gallery-grid glass-box">
        {images.map((image, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => setCurrentIndex(index)}
          >
            <img src={image} alt={`CPIT ${index + 1}`} className="gallery-img" />
          </div>
        ))}
      </div>

      {/* 🔹 Modal for Enlarged Image */}
      {currentIndex !== null && (
        <div className="image-modal" onClick={() => setCurrentIndex(null)}>
          <button className="nav-btn prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
            ❮
          </button>
          <img
            src={images[currentIndex]}
            alt="Enlarged View"
            className="modal-img"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="nav-btn next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
            ❯
          </button>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
